import { cn } from "@/lib/utils";

const ORDER = {
  Pending: "bg-amber-100 text-amber-800 border-amber-200",
  Approved: "bg-emerald-100 text-emerald-800 border-emerald-200",
  Shipped: "bg-indigo-100 text-indigo-800 border-indigo-200",
  Delivered: "bg-teal-100 text-teal-800 border-teal-200",
  Rejected: "bg-rose-100 text-rose-800 border-rose-200",
  Cancelled: "bg-slate-200 text-slate-700 border-slate-300",
};
const STOCK = {
  Healthy: "bg-emerald-100 text-emerald-800 border-emerald-300",
  Low: "bg-amber-100 text-amber-800 border-amber-300",
  Critical: "bg-red-100 text-red-800 border-red-300",
};

export const StatusBadge = ({ status, className }) => (
  <span data-testid={`status-badge-${status?.toLowerCase()}`} className={cn("inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-semibold", ORDER[status] || "bg-slate-100 text-slate-700", className)}>
    {status}
  </span>
);

export const StockBadge = ({ status, className }) => (
  <span className={cn("inline-flex items-center gap-1.5 rounded-full border px-2.5 py-0.5 text-xs font-semibold", STOCK[status] || "bg-slate-100", className)}>
    <span className={cn("h-1.5 w-1.5 rounded-full", status === "Healthy" ? "bg-emerald-500" : status === "Low" ? "bg-amber-500" : "bg-red-600 animate-pulse")} />
    {status}
  </span>
);

export const RoleBadge = ({ role }) => {
  const map = {
    admin: ["Central Admin", "bg-red-100 text-red-800 border-red-200"],
    regional_manager: ["Regional Manager", "bg-sky-100 text-sky-800 border-sky-200"],
    store_user: ["Store User", "bg-emerald-100 text-emerald-800 border-emerald-200"],
    warehouse: ["Warehouse", "bg-amber-100 text-amber-800 border-amber-200"],
  };
  const [label, cls] = map[role] || [role, "bg-slate-100"];
  return <span data-testid="role-badge" className={cn("inline-flex rounded-full border px-2 py-0.5 text-[11px] font-semibold uppercase tracking-wide", cls)}>{label}</span>;
};
